import { DetailPage } from '../../../pages/detail/DetailPage';
import { AssetType } from '../../../api/models/Shared.types';
import { DetailTranslationKeys } from '../../../api/models/TranslationKeys';
import { DetailAction } from './DetailAction';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';
import { Backend } from '../../../api/Backend';
import { VodStreamRights } from '../vod/VodStreamRights';
import { IVodPriceBundleResponse } from '../../../api/models/AndromeTV.types';
import { OptionData } from '../../../components/option/OptionData';

export class VodBundleAction extends DetailAction {
  private streamRights: VodStreamRights;
  private vodId: string;
  constructor(backend: Backend, vodId: string, streamRights: VodStreamRights) {
    super(backend);
    this._backend = backend;
    this.streamRights = streamRights;
    this.vodId = vodId;
  }

  override doAction() {
    if (this.streamRights && this.streamRights.hasBundles()) {
      const bundles = this.streamRights.getBundles();
      if (bundles.length > 1) {
        this.showOptions(bundles);
      } else if (bundles.length === 1) {
        if (bundles[0]) this.openBundleDetail(bundles[0]);
      }
    }
  }

  showOptions(bundles: IVodPriceBundleResponse[]) {
    this.owner?.fireAncestors('$openDialog', {
      type: SelectOptionDialog,
      params: {
        backend: this._backend,
        name: 'Select bundle option page',
        title: this._backend.translations.forKey(DetailTranslationKeys.detail_btn_bundle),
        options: bundles.map(b => ({ text: b.title, value: b })),
        onSuccess: (val: OptionData) => {
          this.hideOptions();
          this.openBundleDetail(val.value);
        },
        onCancelled: this.hideOptions.bind(this),
      },
    });
  }

  openBundleDetail(bundle: IVodPriceBundleResponse) {
    this.owner?.fireAncestors('$openModal', DetailPage, {
      backend: this._backend,
      assetType: AssetType.BUNDLE,
      assetId: bundle.bundleId,
    });
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }
}
